export const Footer = () => (
  <footer className="border-t border-white/10" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-5 py-16 md:flex-row md:items-end md:justify-between md:px-10">
      <div>
        <div className="flex items-center gap-4">
          <img src="/logo.png" alt="Rest Recovery Wellness North PHX logo" className="h-12 w-auto" />
          <p className="font-display text-xl font-black uppercase leading-tight tracking-tight">
            REST Recovery<br /><span className="text-zinc-500">Wellness — North PHX</span>
          </p>
        </div>
        <p className="mt-4 max-w-xs text-sm text-zinc-500">
          North Phoenix's complete performance, recovery and wellness destination.
        </p>
      </div>
      <div className="flex flex-col gap-3 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
        <a href="#modalities" data-testid="footer-link-modalities" className="transition-colors duration-300 hover:text-white">Modalities</a>
        <a href="#capsule" data-testid="footer-link-capsule" className="transition-colors duration-300 hover:text-white">Infinity Capsule</a>
        <a href="#faq" data-testid="footer-link-faq" className="transition-colors duration-300 hover:text-white">FAQ</a>
        <a
          href="tel:+16028353009"
          data-testid="footer-link-phone"
          className="transition-colors duration-300 hover:text-white"
        >
          602-835-3009
        </a>
        <a
          href="https://www.instagram.com/restrecoverynorthphx"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-link-instagram"
          className="transition-colors duration-300 hover:text-white"
        >
          @restrecoverynorthphx
        </a>
        <a
          href="#offer"
          data-testid="footer-cta-claim"
          className="text-rest-red transition-colors duration-300 hover:text-white"
        >
          Claim My Free Recovery Experience
        </a>
      </div>
    </div>
    <div className="border-t border-white/10 px-5 py-6 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600 md:px-10">
      © {new Date().getFullYear()} Rest Recovery Wellness — 8155 W Bell Rd, Suite 112, Peoria, AZ 85382.
    </div>
  </footer>
);
